import Layout from "../components/layout";
import React, {useEffect, useState} from "react";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import {toast} from "react-toastify";
import {useHistory} from "react-router";
import cn from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";

function UsersView() {

    const history = useHistory();
    const [colapse, setColapse] = useState({})
    const [reload, setReload] = useState(false);
    const doReload = () => {
        setReload(!reload)
    }

    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(0)
    const [limit] = useState(20)
    const [totalSize, setTotalSize] = useState(0)

    useEffect(() => {
        axios({
            method: "get",
            url: Endpoints.USERS + `?limit=${limit}&offset=${page * limit}`,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            setUsers(res.data.users || [])
            setTotalSize(res.data.total_size || 0)
            setColapse({})
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        toast.warn("Diese Bestellung kennen wir nicht...")
                        break;
                    case 403:
                        history.push("/")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }, [page, limit, reload])

    const handlePrevious = () => {
        if ((page - 1) <= 0) {
            setPage(0)
        } else {
            setPage(page - 1)
        }
    }

    const handleNext = () => {
        if ((page + 1) < Math.ceil(totalSize / limit)) {
            setPage(page + 1)
        } else {
            setPage(Math.ceil(totalSize / limit) - 1)
        }

    }

    const handleChangeAdmin = (e, user) => {
        e.preventDefault()
        e.stopPropagation()

        axios({
            method: "patch",
            url: Endpoints.CHANGE_USER_PERMISSIONS(user.id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                "admin": !user["is_admin"],
            }
        }).then(res => {
            doReload()
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 404:
                        toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    const handleChangeVerwaltung = (e, user) => {
        e.preventDefault()
        e.stopPropagation()

        axios({
            method: "patch",
            url: Endpoints.CHANGE_USER_PERMISSIONS(user.id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                "verwaltung": !user["is_verwaltung"],
            }
        }).then(res => {
            doReload()
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 404:
                        toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    const handleNotificationTest = (e, user) => {
        e.preventDefault()
        e.stopPropagation()

        axios({
            method: "post",
            url: Endpoints.TEST_USER_NOTIFIACIOTNS(user.id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {}
        }).then(res => {
            doReload()
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 404:
                        toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    return (
        <Layout>
            <div className="card">
                <div className="card-body">
                    <h2 className="card-title text-center"><FontAwesomeIcon className="text-primary"
                                                                            icon={["fas", "users"]}/> Users</h2>
                    <h6 className="card-subtitle mb-2 text-muted text-center"><span
                        className="badge bg-primary text-light">{totalSize}</span></h6>
                </div>
                <ul className="list-group list-group-flush">
                    {
                        users.map(e => (
                            <li className="list-group-item" key={e.id}>
                                <div className="row" onClick={() => {
                                    setColapse({
                                        ...colapse,
                                        [e.id]: !(colapse[e.id] || false)
                                    })
                                }}>
                                    <div className="col-md-2 d-flex align-items-center">{e.id}</div>
                                    <div className="col-md-4 d-flex align-items-center">{e.username}</div>
                                    <div className="col-md-4 d-flex align-items-center">{e.email}</div>
                                    <div className="col-md-2">
                                        <div className="btn-group" role="group">
                                            {e["is_admin"] ? (<span className="badge bg-danger">Admin</span>) : null}
                                            {e["is_verwaltung"] ? (
                                                <span className="badge bg-warning">Verwaltung</span>) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className={cn("collapse", {
                                    "show": colapse[e.id] || false
                                })}>
                                    <hr/>
                                    <div className="row pb-2">
                                        <div className="col-2">Erstellt am:</div>
                                        <div className="col-2"><span
                                            className="badge bg-success">{dayjs(e["created_at"]).format("DD.MM.YYYY HH:mm")}</span>
                                        </div>
                                        <div className="col-2">Aktualisiert am:</div>
                                        <div className="col-2"><span
                                            className="badge bg-success">{dayjs(e["updated_at"]).format("DD.MM.YYYY HH:mm")}</span>
                                        </div>
                                        <div className="col-2">Status:</div>
                                        <div className="col-2">{
                                            e["status"] === 0 ? (
                                                <span className="badge bg-success">aktiv</span>
                                            ) : e["status"] === -1 ? (
                                                <span className="badge bg-danger">inaktiv</span>
                                            ) : null
                                        }</div>
                                    </div>
                                    <div className="row pb-2">
                                        <div className="d-flex justify-content-end">
                                            <div className="btn-group" role="group" aria-label="Basic example">
                                                <div className={cn("btn", {
                                                    "btn-outline-danger": !e["is_admin"],
                                                    "btn-danger": e["is_admin"],
                                                })} onClick={y => handleChangeAdmin(y, e)}><FontAwesomeIcon className=""
                                                                                                            icon={["fas", "user-shield"]}/>
                                                </div>
                                                <div className={cn("btn", {
                                                    "btn-outline-warning": !e["is_verwaltung"],
                                                    "btn-warning": e["is_verwaltung"],
                                                })} onClick={y => handleChangeVerwaltung(y, e)}><FontAwesomeIcon
                                                    className="" icon={["fas", "book-reader"]}/></div>
                                                <div className="btn btn-secondary"
                                                     onClick={y => handleNotificationTest(y, e)}><FontAwesomeIcon
                                                    className="" icon={["fas", "envelope"]}/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))
                    }
                </ul>
                <nav className="card-footer d-flex justify-content-center align-items-center">
                    <ul className="pagination mb-0">
                        <li className="page-item">
                            <div className="page-link" onClick={() => handlePrevious()} aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                            </div>
                        </li>
                        {
                            [...Array(Math.ceil(totalSize / limit))].map((e, i) => (
                                <li key={i} className={cn("page-item", {"active": i === page})}>
                                    <div className="page-link" onClick={() => setPage(i)}>{i + 1}</div>
                                </li>
                            ))
                        }
                        <li className="page-item">
                            <div className="page-link" onClick={() => handleNext()} aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </Layout>
    )
}

export default UsersView